import type { ReactNode } from 'react';
import Style from './content.tailwind.js';

interface ContentProps {
  children?: ReactNode;
}

export function Content({ children }: ContentProps) {
  return <div className={Style.content}>{children}</div>;
}
